import { render, staticRenderFns } from "./EditTestimonialpopup.vue?vue&type=template&id=17a6ff92"
import script from "./EditTestimonialpopup.vue?vue&type=script&lang=js"
export * from "./EditTestimonialpopup.vue?vue&type=script&lang=js"
import style0 from "./EditTestimonialpopup.vue?vue&type=style&index=0&id=17a6ff92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports